<footer class="footer">
  @if (groupedFooterItems()) {
    <div class="footer__navigation responsive-row" role="navigation">
      @for (group of groupedFooterItems(); track group.category) {
        <portal-footer-list class="footer__nav-item footer__nav-item--simple-list" [groupedLinkList]="group" />
      }
    </div>
  }
  <span class="footer__version">Version: {{ appVersion() }}.{{ buildNumber() }}</span>
</footer>
